import classnames from "classnames";
import React, { Fragment } from "react";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { DisplayPromotion } from "@components/Product/ECommerce/eCommerce.types";
import { PromotionPeriodComponent } from "@components/Product/PromotionPeriod/promotionPeriod.component";

export type PromotionsProps = {
    promotions: Array<DisplayPromotion>;
    className?: string;
};

const Promotions = ({ promotions, className }: PromotionsProps) => {
    const { t } = useGranite();

    if (promotions.length === 0) {
        return null;
    }

    return (
        <div className={classnames("promo-component mb-2", className)}>
            {promotions.map((promo, index) => (
                <Fragment key={`promo-${index}`}>
                    <div className="promo-component__item d-flex flex-row align-items-center">
                        <div className="promo-component__head">
                            {t("productDetail.promoBanner.head")}
                        </div>
                        <div className="promo-component__info flex-grow-1">
                            {promo.marketingText}
                        </div>
                    </div>
                    {promo.validTo && (
                        <PromotionPeriodComponent
                            className={"promo-component__period"}
                            validFrom={promo.validFrom}
                            validTo={promo.validTo}
                            periodText={promo.periodText}
                        />
                    )}
                </Fragment>
            ))}
        </div>
    );
};

export { Promotions };
